import { Autocomplete, TextField } from '@mui/material';
import { useQuery } from '@parkchirp/api-client';
import { HourlyCategory } from 'parkchirp-shared/enums';
import { useMemo } from 'react';
import { LIST_HOURLY_RATES_BY_CITY } from '../../queries';

interface HourlyRateAutocompleteProps {
	category: HourlyCategory;
	cityId: string | null;
	rate: string | null;
	onChange: (rateId: string | null) => void;
	disabled: boolean;
}

export const HourlyRateAutocomplete = ({ category, cityId, rate, onChange, disabled }: HourlyRateAutocompleteProps) => {
	const { loading: ratesLoading, data: ratesData } = useQuery(LIST_HOURLY_RATES_BY_CITY, {
		variables: {
			category,
			cityId,
		},
		skip: !cityId || !category,
		context: {
			apiVersion: 'v2',
		},
	});

	const rateOptions = useMemo(() => {
		return ratesData?.listHourlyRatesByCity.map((hourlyRate) => ({
			label: hourlyRate.name,
			value: hourlyRate.id,
		}));
	}, [ratesData]);

	return (
		<Autocomplete
			id='rate-autocomplete'
			size='small'
			options={rateOptions || []}
			getOptionLabel={(option) => option.label || ''}
			value={rateOptions?.find((opt) => opt.value === rate) || null}
			onChange={(_, newValue) => onChange(newValue ? newValue.value : null)}
			renderInput={(params) => (
				<TextField
					{...params}
					label='Rate'
					variant='outlined'
					fullWidth
					required
					inputProps={{
						...params.inputProps,
						'data-cy': 'promo-code-rate-autocomplete',
					}}
				/>
			)}
			loading={ratesLoading}
			isOptionEqualToValue={(option, value) => option.value === value.value}
			disabled={disabled}
			fullWidth
		/>
	);
};
